import toast from 'react-hot-toast';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import * as photosApi from '../../api/photosApi';
import * as actions from '../actions';
import * as selectors from '../selectors';

export function* addPhoto({ payload: { photo } }) {
  try {
    yield call(photosApi.add, photo);
    yield put(actions.photos.addPhotoSuccess());
    toast.success('Photo added.');
  } catch (e) {
    yield put(actions.photos.addPhotoFail());
    toast.error('An error occurred adding the photo.');
  }
}
export function* updatePhoto({ payload: { photo } }) {
  try {
    yield call(photosApi.update, photo);
    yield put(actions.photos.updatePhotoSuccess());
    toast.success('Photo updated.');
  } catch (e) {
    yield put(actions.photos.updatePhotoFail());
    toast.error('An error occurred updating the photo.');
  }
}
export function* getPhotos({ payload: { query } }) {
  try {
    yield put(actions.user.setLoading(true));
    const take = 50;
    const page = yield select(selectors.photos.page);
    const { photos, count } = yield call(photosApi.get, { ...query, page: page - 1, take });
    yield put(actions.photos.getPhotosSuccess(photos));
    yield put(actions.photos.setPhotoCount(count));
  } catch (e) {
    yield put(actions.photos.getPhotosFail());
    toast.error('An error occurred retrieving the photos.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}
export function* getUsers() {
  try {
    const users = yield call(photosApi.getUsers);
    yield put(actions.photos.getUsersSuccess(users));
  } catch (e) {
    console.log(e);
    yield put(actions.photos.getUsersFail());
    toast.error('An error occurred retrieving the users.');
  }
}

export function* getPhotoById({ payload: { id } }) {
  try {
    yield put(actions.user.setLoading(true));
    const photo = yield call(photosApi.getById, id);
    yield put(actions.photos.getPhotoByIdSuccess(photo));
  } catch (e) {
    yield put(actions.photos.getPhotoByIdFail());
    toast.error('An error occurred retrieving the photo.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* searchPhotos({ payload: { query } }) {
  try {
    yield put(actions.user.setLoading(true));
    const take = 50;
    const page = yield select(selectors.photos.page);
    const { photos, count } = yield call(photosApi.search, { ...query, page: page - 1, take });
    yield put(actions.photos.setPhotoCount(count));
    yield put(actions.photos.searchPhotosSuccess(photos));
  } catch (e) {
    yield put(actions.photos.searchPhotosFail());
    toast.error('An error occurred retrieving the photos.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* photoSagas() {
  yield takeEvery(actions.photos.addPhoto, addPhoto);
  yield takeEvery(actions.photos.updatePhoto, updatePhoto);
  yield takeEvery(actions.photos.getPhotos, getPhotos);
  yield takeEvery(actions.photos.getPhotoById, getPhotoById);
  yield takeEvery(actions.photos.searchPhotos, searchPhotos);
  yield takeEvery(actions.photos.getUsers, getUsers);
}
